import { useEffect } from "react";

import { useNavigate, useParams } from "@tanstack/react-router";
import { ThreeDots } from "react-loader-spinner";

import { useCaseByCaseNumber } from "@/hooks/queries/use-cases";

const ReportGeneratorCaseDetailPage = () => {
  const { id: caseNumber } = useParams({ strict: false }) as { id: string };
  const navigate = useNavigate();
  const { data: caseDetail, isLoading } = useCaseByCaseNumber({
    case_number: caseNumber || "",
  });

  useEffect(() => {
    if (!isLoading && caseDetail?.template?.id) {
      navigate({
        to: `/report-studio/${caseNumber}/report-builder/template/${caseDetail.template.id}`,
        replace: true,
      });
    }
  }, [isLoading, caseDetail, caseNumber, navigate]);

  return (
    <div className="flex h-full items-center justify-center">
      <ThreeDots
        visible={true}
        height="60"
        width="60"
        color="#00BFFF"
        radius="9"
        ariaLabel="loading"
      />
    </div>
  );
};

export default ReportGeneratorCaseDetailPage;
